// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import Html5TwoToneSvg from "@fishx/icons-svg/es/asn/Html5TwoTone";
import FishxIcon from '../components/FishxIcon';

var Html5TwoTone = function Html5TwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: Html5TwoToneSvg
  }));
};

Html5TwoTone.displayName = 'Html5TwoTone';
export default React.forwardRef(Html5TwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/Html5TwoTone.js
// module id = 2945
// module chunks = 0